/**
 * 商品グループ関連のQuery Hooks
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getProductGroupTrees, getProductGroupTreesExtended } from '@/lib/api/product-group-tree';
import { productGroupKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * 商品グループ階層一覧を取得するQuery Hook
 * @param accountCode アカウントコード
 */
export function useProductGroups(accountCode: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: productGroupKeys.list(accountCode),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getProductGroupTrees(accountCode, authHeaders);
    },
    enabled: !authHeaderLoading && isAuthorized && !!accountCode,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}

/**
 * 拡張版商品グループ階層一覧を取得するQuery Hook
 * @param accountCode アカウントコード
 */
export function useProductGroupsExtended(accountCode: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: productGroupKeys.extended(accountCode),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getProductGroupTreesExtended(accountCode, authHeaders);
    },
    enabled: !authHeaderLoading && isAuthorized && !!accountCode,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
